module.exports = __webpack_public_path__ + "media/images/favicon/favicon-e02b12f6d37596c9e67e213d8e9e981e.png";